import { queryKeys } from "../queryKeys";
import {
  getOptionsApprovalStatus,
  type OptionsApprovalStatus,
} from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOptionsApprovalStatus = ({
  accountID,
  options,
}: {
  accountID?: string;
  options?: QueryOptions<OptionsApprovalStatus>;
}) => {
  const { data, isLoading } = useRequest(
    queryKeys.options.approvalStatus(accountID || ""),
    () => {
      if (!accountID) {
        throw new Error("accountID required");
      }
      return getOptionsApprovalStatus(accountID);
    },
    {
      ...options,
      enabled: Boolean(accountID) && (options?.enabled ?? true),
    },
  );

  return { data, isLoading };
};
